import validate from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.6.5_@types+node@18.0.0_eslint@8.46.0_sass@1.63.6_typescript@5.1.6/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {
  kvbindingmiddleware: () => import("/opt/buildhome/repo/middleware/kvbindingmiddleware.ts")
}